import "slick-carousel";

import "slick-carousel/slick/slick.css";

$(document).ready(() => {
  $("#homeSlider").slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    appendDots: $("#homeDots"),
    autoplay: true,
    fade: true,
    pauseOnHover: false,
    autoplaySpeed: 3000
  });
});
